var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 11.375L23.1697 16.0122L28.5599 17.594L25.1287 22.0415L25.2899 27.656L20.0002 25.7675L14.7104 27.656L14.8717 22.0415L11.4404 17.594L16.8307 16.0122L20.0002 11.375ZM20.0002 14.033L17.7667 17.3015L13.9679 18.4152L16.3867 21.5487L16.2719 25.505L20.0002 24.1745L23.7277 25.505L23.6137 21.5487L26.0317 18.4152L22.2337 17.3015L20.0002 14.033ZM18.5002 20C18.5002 20.3978 18.6582 20.7794 18.9395 21.0607C19.2208 21.342 19.6024 21.5 20.0002 21.5C20.398 21.5 20.7795 21.342 21.0608 21.0607C21.3421 20.7794 21.5002 20.3978 21.5002 20H23.0002C23.0002 20.7956 22.6841 21.5587 22.1215 22.1213C21.5589 22.6839 20.7958 23 20.0002 23C19.2045 23 18.4415 22.6839 17.8789 22.1213C17.3162 21.5587 17.0002 20.7956 17.0002 20H18.5002Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.18a7954aeb99a4839ae8cd0c3fc4d898.svg";
export { ForwardRef as ReactComponent };